import { render, staticRenderFns } from "./LiteracyComponent6.vue?vue&type=template&id=540ab683&scoped=true&"
import script from "./LiteracyComponent6.vue?vue&type=script&lang=js&"
export * from "./LiteracyComponent6.vue?vue&type=script&lang=js&"
import style0 from "./LiteracyComponent6.vue?vue&type=style&index=0&id=540ab683&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540ab683",
  null
  
)

export default component.exports